<template>
  <div :class="$style.labelContainer">
    <div :class="[$style.labelMain, $style.flex, $style.justifyBetween]">
      <div :class="[$style.flex, $style.flexAuto]">
        <!-- Hidden references to the classes to prevent tree shaking -->
        <div v-if="iconColor === 'blue'" :class="[$style.icon, $style.iconBlue]"></div>
        <div v-if="iconColor === 'green'" :class="[$style.icon, $style.iconGreen]"></div>
        <div v-if="iconColor === 'gray'" :class="[$style.icon, $style.iconGray]"></div>
        <div v-if="iconColor === 'none'" :class="$style.icon"></div>
        <span :class="[$style.labelName]">{{ labelName }}</span>
        <span :class="$style.labelHint">{{ labelHint }}</span>
        <HgTooltip v-if="tooltipContent">
          {{ tooltipContent }}
        </HgTooltip>
      </div>
      <div :class="[$style.flexInitial]">
        <span :class="[$style.price]">{{ formattedPrice }}</span>
      </div>
    </div>
    <div v-for="(extraItem, index) in labelExtra" :key="index" :class="$style.labelExtra">
      {{ extraItem }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { HgTooltip } from '@smg-real-estate/domus';

defineProps({
  iconColor: {
    type: String,
    required: false,
    default: 'none',
    validator(value: string) {
      const allowedColors = ['blue', 'green', 'gray', 'none'];
      return allowedColors.includes(value as string);
    },
  },
  labelName: {
    type: String,
    required: true,
  },
  formattedPrice: {
    type: String,
    required: true,
  },
  labelHint: {
    type: String,
    required: false,
    default: '',
  },
  labelExtra: {
    type: Array,
    required: false,
    default: () => [],
    validator(value: any) {
      // Check if the value is an array of strings
      if (Array.isArray(value)) {
        return value.every((item) => typeof item === 'string');
      }
      return false;
    },
  },
  tooltipContent: {
    type: String,
    required: false,
    default: '',
  },
});
</script>

<style lang="scss" module>
@import '@/assets/mixins';

.labelContainer {
  margin-top: $space-100;

  &:first-of-type {
    margin-top: 0;
  }
}

.labelMain > * {
  line-height: 21px; // Fixed to align the different text sizes on the same line
}

.labelExtra {
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
}

.icon {
  width: $space-100;
  height: $space-100;
  margin-top: 2px;
  margin-right: $space-75;
  margin-left: $space-75;
  border-radius: 50%;

  &.iconBlue {
    background: linear-gradient(90deg, #288dcc, #2b3486);
  }

  &.iconGreen {
    background: linear-gradient(90deg, #53b2b8, #56ace5);
  }

  &.iconGray {
    background: linear-gradient(0deg, #afbeca, #dfe4e9);
  }
}

.labelName {
  max-width: 80%;
  margin-right: $space-75;
}

.labelHint {
  @include caption;

  & {
    color: $color-deep-blue-80;
  }
}

.labelExtra {
  @include caption;

  & {
    margin-top: $space-25;
    margin-left: $space-250;
  }

  &:last-of-type {
    margin-bottom: 0;
  }
}

.price {
  @include body-2;
}

.flex {
  display: flex;
}

.flexAuto {
  flex: 1 1 auto;
}

.flexInitial {
  flex: 0 1 auto;
}

.justifyBetween {
  justify-content: space-between;
}
</style>
